import styled from 'styled-components';
import { ColorMixin } from '../../../styles/global';

export const Container = styled.div`
  h2 {
    color: White;
    font-size: 24px;
    margin-bottom: 40px;
  }
  .socials {
    display: flex;
    flex-direction: column;
    a {
      margin-top: 5px;
      font-size: 20px;
      text-decoration: none;
      color: white;
      gap: 15px;
      display: flex;
      align-items: center;

      &:hover {
        color: ${ColorMixin?.active};
      }
    }
  }

  @media screen and (max-width: 800px) {
    border-top: 1px solid #eee;
    margin: 100px 0 50px;
    padding: 30px 0;
    text-align: center;
  }
`;
